import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

export const PhotoUploader = ({ value, onChange, max = 5, testId = "photo-uploader", privateUpload = false }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    const list = Array.from(files).slice(0, max - value.length);
    if (!list.length) return;
    setUploading(true);
    const added = [];
    for (const file of list) {
      const form = new FormData();
      form.append("file", file);
      try {
        const { data } = await api.post(privateUpload ? "/uploads?private=true" : "/uploads", form);
        added.push(data.path);
      } catch (e) {
        toast.error(errMsg(e, "Gagal mengunggah foto"));
      }
    }
    onChange([...value, ...added]);
    setUploading(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className="flex flex-wrap gap-3" data-testid={testId}>
      {value.map((p, i) => (
        <div key={p} className="relative h-24 w-24 overflow-hidden rounded-xl border border-stone-200">
          <img src={fileUrl(p)} alt="" className="h-full w-full object-cover" />
          <button
            type="button"
            data-testid={`${testId}-remove-${i}`}
            onClick={() => onChange(value.filter((x) => x !== p))}
            className="absolute right-1 top-1 rounded-full bg-white/90 p-1 text-stone-700 hover:bg-white"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
      {value.length < max && (
        <button
          type="button"
          data-testid={`${testId}-add`}
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="flex h-24 w-24 flex-col items-center justify-center gap-1 rounded-xl border border-dashed border-stone-300 bg-stone-50 text-xs text-stone-500 transition-colors hover:border-teal-600 hover:text-teal-700"
        >
          {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />}
          {uploading ? "Mengunggah" : "Tambah foto"}
        </button>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple={max > 1}
        className="hidden"
        data-testid={`${testId}-input`}
        onChange={(e) => handleFiles(e.target.files)}
      />
    </div>
  );
};
